/*this is hot deal card */
import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import Navbar from "../../../components/user/navbar/Navbar";
import Footer from "../../../components/user/footer/Footer";
import SimpleBanner from "../../../components/user/general/SimpleBanner";
import "../../../assets/css/user/card/cardDetailPage/CardDetailPage.css";
import "../../../assets/css/user/general/simpleBanner.css";

import { useContext } from "react";
import AppContext from "../../../context/AppContext";

const images = [
  "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80",
  "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80",
  "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80",
  "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80",
];

const CardDetailPage = () => {
  const [mainImage, setMainImage] = useState(images[0]);

  const { addToDealBox } = useContext(AppContext);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <Container fluid>
      <Navbar />

      {/* SimpleBanner with props and safe breadcrumb */}
      <SimpleBanner
        title="Spa & Wellness Deal"
        subtitle="Relax, rejuvenate, and save more with exclusive offers"
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "Deals", href: "/all-deals" },
          { label: "Deal Details", current: true },
        ]}
      />

      <div className="spa-detail-wrapper">
        <div className="spa-detail-container">
          {/* Time Slot Banner */}
          <div className="time-slot-banner">
            <div className="time-slot-badge">⏰ WINDOW SLOT: 20 MINUTES</div>
            <div className="location-info">
              <span>📍</span>
              <span>5305.19 mi</span>
            </div>
          </div>

          <div className="container">
            <div className="row g-0">
              {/* LEFT: Images */}
              <div className="col-lg-6">
                <div className="image-section">
                  <div className="main-image-wrapper">
                    <img src={mainImage} alt="Spa" className="main-image" />
                  </div>
                  <div className="thumbnail-grid">
                    {images.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt="thumbnail"
                        onClick={() => setMainImage(img)}
                        className={`thumbnail ${
                          mainImage === img ? "active" : ""
                        }`}
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* RIGHT: Product Info */}
              <div className="col-lg-6">
                <div className="info-section">
                  <div className="discount-badge">10% OFF</div>

                  <h1 className="product-title">
                    Full Body Wax & 50-Minute Massage Package
                  </h1>

                  <p className="product-description">
                    Indulge in the ultimate relaxation experience with our
                    premium spa package. Enjoy a complete full body wax followed
                    by a luxurious 50-minute couples or solo massage session
                    designed to rejuvenate your body and mind.
                  </p>

                  {/* Services Included */}
                  <div className="services-box">
                    <h3 className="services-title">Package Includes:</h3>
                    <div className="services-list">
                      <div className="service-item">
                        <span className="check-icon">✓</span>
                        <div className="service-details">
                          <div className="service-name">Full Body Wax</div>
                          <div className="service-price">
                            Regular price: PKR100
                          </div>
                        </div>
                      </div>
                      <div className="service-item">
                        <span className="check-icon">✓</span>
                        <div className="service-details">
                          <div className="service-name">
                            50-Minute Couples or Solo Massage
                          </div>
                          <div className="service-price">
                            Regular price: PKR146
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Pricing */}
                  <div className="pricing-section">
                    <span className="original-price">PKR246</span>
                    <span className="discounted-price">PKR221.4</span>
                    <span className="savings-badge">Save PKR24.6</span>
                  </div>

                  {/* Action Buttons */}

                  <button
                    className="btn-dealbox"
                    onClick={() =>
                      addToDealBox({
                        id: 1,
                        title: "Full Body Wax & Massage",
                        price: 221.4,
                        image: mainImage,
                      })
                    }
                  >
                    Add to DealBox
                  </button>
                  {/* <div className="action-buttons">
                    <button className="btn-dealbox">Add to DealBox</button>
                    <button className="btn-favorite">❤️</button>
                  </div> */}

                  {/* Features */}
                  <div className="features-grid">
                    <div className="feature-item">
                      <span className="feature-icon">⏱️</span>
                      <span className="feature-text">
                        20-min booking window
                      </span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-icon">👥</span>
                      <span className="feature-text">Couples or Solo</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-icon">✨</span>
                      <span className="feature-text">Premium products</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-icon">🎁</span>
                      <span className="feature-text">Gift-ready package</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </Container>
  );
};

export default CardDetailPage;

